var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import AbstractConnection from './AbstractConnection';

var HttpConnection = function (_AbstractConnection) {
  _inherits(HttpConnection, _AbstractConnection);

  function HttpConnection(url, dispatcher) {
    _classCallCheck(this, HttpConnection);

    var _this = _possibleConstructorReturn(this, (HttpConnection.__proto__ || Object.getPrototypeOf(HttpConnection)).call(this, url, dispatcher));

    _this.dispatcher = dispatcher;
    _this.dispatcher.state = 'connected';
    _this.url = url + '/components';
    return _this;
  }

  _createClass(HttpConnection, [{
    key: 'sendEvent',
    value: function sendEvent(event) {
      var _this2 = this;

      if (event.type === 'unsubscribe') return;

      _get(HttpConnection.prototype.__proto__ || Object.getPrototypeOf(HttpConnection.prototype), 'sendEvent', this).call(this, event);
      var query = event.serializeParams(Object.assign({}, this.dispatcher.query, event.params));

      fetch(this.url + '?' + query, { credentials: 'include' }).then(function (res) {
        return res.json();
      }).then(function (data) {
        // register channel
        _this2.dispatcher.newMessage({
          id: data.id,
          channel: event.channel
        });

        // Emit meta event
        _this2.dispatcher.newMessage({
          id: data.id,
          type: 'meta',
          values: data.meta
        });

        // Send data events
        var synthesizeEvent = function synthesizeEvent(row) {
          row.type = 'new';
          row.id = data.id;

          _this2.dispatcher.newMessage(row);
        };

        if (data.rows) {
          data.rows.forEach(synthesizeEvent);
        }

        _this2.dispatcher.newMessage({
          id: data.id,
          type: 'meta',
          values: { initial_data_sent: true }
        });
      }).catch(function (err) {
        throw new Error(err);
      });
    }
  }]);

  return HttpConnection;
}(AbstractConnection);

export default HttpConnection;